<template>
  <div id="contenedor-editar-contrato-fecha">
    <v-form
      v-model="formularioValido"
      ref="actualizarContratoFecha">
      <v-card>
          <v-card-title>
            Editar fecha
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <custom-select
                  v-model="fecha.tipo"
                  :items="listadoTipos"
                  item-text="name"
                  item-value="id"
                  label="Tipo"
                  :rules="[mixReglas.requerido]">
                </custom-select>
              </v-col>
              <date-picker
                v-model="fecha.fecha"
                label="Fecha"
                :rules="[mixReglas.requerido]">
              </date-picker>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              @click="cerrar"
              tipo="formCancelar"
              label="Cancelar"
              class="mr-3">
            </custom-button>
            <custom-button
              @click="mixActualizarContratoFecha"
              :disabled="!formularioValido || enviandoFormulario"
              :loading="enviandoFormulario"
              tipo="formAceptar"
              label="Guardar">
            </custom-button>
          </v-card-actions>
        </v-card>
    </v-form>
  </div>
</template>

<script>
import DatePicker from '@/components/inputs/DatePicker.vue';
import CustomSelect from '@/components/inputs/sinColumnas/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixContratoFechas from './mixContratoFechas';

export default {
  components: {
    CustomSelect,
    CustomButton,
    DatePicker,
  },
  mixins: [mixContratoFechas],
  props: {
    idContrato: {
      type: String,
      required: true,
    },
    fechaEditar: {
      type: Object,
      required: true,
    },
    tiposAgregados: {
      type: Array,
    },
  },
  name: 'EditarContratoFecha',
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      fecha: {
        tipo: this.fechaEditar.tipo,
        fecha: this.fechaEditar.fecha,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.actualizarContratoFecha.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
  computed: {
    listadoTipos() {
      const tiposAgregados = this.tiposAgregados.filter((tipo) => tipo !== this.fechaEditar.tipo);
      return this.tipos.filter(({ id }) => !tiposAgregados
        .filter((tipo) => tipo !== 'fecha-de-suspension-de-trabajos')
        .filter((tipo) => tipo !== 'fecha-de-reinicio-de-trabajos')
        .includes(id));
    },
  },
};
</script>

<style lang="scss">

</style>
